import { ProjectStatusEnum } from 'api-hooks/projects/common';
import { TourStatusEnum } from 'api-hooks/tour/common';
import { TransactionalStatusEnum } from 'common/constants/enum';
import { PillStatus } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

interface Props {
  value: string;
  style?: StyleObject | any;
}

export default function TourPillStatus(props: Props) {
  const { t } = useTranslation();
  const { value, style } = props;
  let status: 'blue' | 'brown' | 'green' | 'red' | 'yellow' | 'other';
  let text: string = '-';

  switch (value) {
    case TourStatusEnum.active:
      status = 'green';
      text = t('status:active');
      break;
    case TourStatusEnum.pending_approval:
    case TransactionalStatusEnum.VoidDraft:
    case ProjectStatusEnum.cancel_draft:
    case ProjectStatusEnum.pending_cancel_approval:
    case TourStatusEnum.draft:
    case TourStatusEnum.close_draft:
    case TourStatusEnum.pending_close_approval:
    case TourStatusEnum.pending_revert_close_approval:
    case TourStatusEnum.revert_close_draft:
      status = 'yellow';

      if (value === TourStatusEnum.pending_close_approval) {
        text = t('status:pending_close_approval');
      } else if (value === TourStatusEnum.pending_revert_close_approval) {
        text = t('status:pending_revert_close_approval');
      } else if (value === TourStatusEnum.revert_close_draft) {
        text = t('status:revert_close_draft');
      } else {
        text = t(`status:${value}`);
      }
      break;
    case TourStatusEnum.rejected_approval:
      status = 'red';
      if (value === TourStatusEnum.rejected_approval) {
        text = t('status:rejected');
      }
      break;
    case ProjectStatusEnum.canceled:
      status = 'brown';
      text = t('status:canceled');
      break;

    case TourStatusEnum.waiting:
    case TourStatusEnum.closed:
    default:
      if (value === TourStatusEnum.waiting) text = t('status:waiting');
      else text = t(`status:${value}`);

      status = 'other';
      break;
  }
  return <PillStatus $style={style} status={status} children={text} />;
}
